import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
  Button,
  Grid,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Box,
  Divider,
} from '@material-ui/core';
import { Search as SearchIcon, Clear as ClearIcon } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

function UserFilters({
  searchName,
  searchEmail,
  selectedRole,
  roles,
  onSearchNameChange,
  onSearchEmailChange,
  onSelectedRoleChange,
  onClearSearch,
  onSearch,
}) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader title={t('Search bar')} />
      <Divider />
      <CardContent>
        <Grid container spacing={3}>
          {/* Campo Nombre */}
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label={t('Name')}
              placeholder={t('Type a name')}
              value={searchName}
              onChange={onSearchNameChange}
              variant="outlined"
              size="small"
            />
          </Grid>

          {/* Campo Email */}
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label={t('Email')}
              placeholder={t('Type an email')}
              value={searchEmail}
              onChange={onSearchEmailChange}
              variant="outlined"
              size="small"
            />
          </Grid>

          {/* Selector de Rol */}
          <Grid item xs={12} md={4}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel>{t('Filter by role')}</InputLabel>
              <Select
                value={selectedRole}
                onChange={onSelectedRoleChange}
                label={t('Filter by role')}>
                <MenuItem value="">
                  <em>{t('All roles')}</em>
                </MenuItem>
                {roles.map((role) => (
                  <MenuItem key={role.value} value={role.value}>
                    {role.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Botones de acción */}
        <Box mt={3} display="flex" justifyContent="flex-end" mr={2}>
          <Button
            variant="outlined"
            color="default"
            style={{ marginRight: '16px' }}
            startIcon={<ClearIcon />}
            onClick={onClearSearch}>
            {t('Clear search')}
          </Button>
          <Button variant="contained" color="primary" startIcon={<SearchIcon />} onClick={onSearch}>
            {t('Search')}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

export default UserFilters;
